// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loading_loadingContainer__TvxqG","loadingGif":"Loading_loadingGif__sclkH"};